<template>
  <div id="main">
    <!-- {{ searchRounds }} -->
    <Models :rounds="searchRounds" @gamestate="quit" @found="emitFoundModels" />
    <DropZone />
  </div>
</template>

<script>

const Models = () => import('./Models.vue')

const DropZone = () => import('./DropZone.vue')

export default {
  name: 'MainState',
  components: {
    Models,
    DropZone
  },
  props: {
    searchRounds: Number
  },
  methods:{
    quit(){
      this.$emit('gamestate', 'over');
    },
    emitFoundModels(models){
      this.$emit('found', models);
      this.$forceUpdate();
    }
  }
}
</script>
